import { render, staticRenderFns } from "./PhoneWebsite.vue?vue&type=template&id=a19c3ea0&"
import script from "./PhoneWebsite.vue?vue&type=script&lang=js&"
export * from "./PhoneWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports